import { useNavigate } from 'react-router-dom'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Add } from '@factorialco/f0-react/icons/app'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onCreate: () => void
  disabledSubmit: boolean
}

const Header = ({ onCreate, disabledSubmit }: Props) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  return (
    <ResourceHeader
      title={i18n.t('employees.bulk_edit.additional_compensations')}
      primaryAction={{
        label: i18n.t('contract_versions.additional_compensation.bulk_create.create'),
        icon: Add,
        onClick: () => onCreate(),
        disabled: disabledSubmit,
      }}
      secondaryActions={[
        {
          label: i18n.t('contract_versions.additional_compensation.bulk_create.cancel'),
          onClick: () => navigate(navigation.employees.list.fullPath()),
          variant: 'critical',
        },
      ]}
    />
  )
}

export default Header
